import { Collapsible } from '../interfaces';
import { PartyRole } from './party-role';
import { TransactionType } from './transaction-type';
import { Study } from './study';
import { TransactionValueEnteredInEnum } from './enums';
import { Entity } from '.';

export class BaseTransaction implements Collapsible {
  transactionId: number;
  identifier: string;
  propertyTransferred: string;
  units: number;
  value: number;
  description: string;
  partyRole: PartyRole = new PartyRole();
  transactionType: TransactionType = new TransactionType();
  transferDateDay = '';
  transferDateMonth = '';
  transferDateYear = '';
  collapsed: boolean;
  study: Study;
  valueEnteredIn: TransactionValueEnteredInEnum;
  transferDate?: string; // used for displaying date in lists
  localValue?: string;
  isSource?: boolean;
  entity?: Entity;
}
